// ─────────────────────────────────────────────────────────────
// StarRating — read-only or interactive 5-star rating widget.
// Extracted from ScriptsTab so both ScriptsTab and CommunityTab
// can share the same component without circular imports.
// ─────────────────────────────────────────────────────────────

import { useState } from "react";
import { Box } from "@mui/material";

export interface StarRatingProps {
  value: number;
  interactive?: boolean;
  onChange?: (val: number) => void;
}

export function StarRating({ value, interactive = false, onChange }: StarRatingProps) {
  const [hovered, setHovered] = useState(0);
  return (
    <Box
      component="span"
      role={interactive ? undefined : "img"}
      aria-label={interactive ? undefined : `${value.toFixed(1)} out of 5 stars`}
      sx={{ display: "inline-flex", alignItems: "center", gap: 0.125 }}
    >
      {[1, 2, 3, 4, 5].map((i) => (
        <Box
          key={i}
          component={interactive ? "button" : "span"}
          onClick={interactive && onChange ? () => onChange(i) : undefined}
          onMouseEnter={interactive ? () => setHovered(i) : undefined}
          onMouseLeave={interactive ? () => setHovered(0) : undefined}
          sx={{
            fontSize: "0.8125rem",
            color: i <= (hovered || Math.round(value)) ? "warning.main" : "text.disabled",
            cursor: interactive ? "pointer" : "default",
            background: "none",
            border: "none",
            p: 0,
            lineHeight: 1,
            "&:focus-visible": { outline: "2px solid", outlineColor: "primary.main" },
          }}
          aria-label={interactive ? `Rate ${i} out of 5 stars` : undefined}
        >
          ★
        </Box>
      ))}
    </Box>
  );
}
